/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1201px){.badges-container[_ngcontent-%COMP%]{width:70rem}}@media (min-width:991px) and (max-width:1200px){.badges-container[_ngcontent-%COMP%]{width:59rem}}"];
export { styles as styles };
//# sourceMappingURL=progress-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/progress/progress-page/progress-page.component.scss.shim.ngstyle.js
// module id = 1673
// module chunks = 27 28 29